import * as React from 'react';

/** Shared state for controlling lipsync video playback in the chat header. */
export interface HeaderVideoContextValue {
  activeVideoUrl: string | null;
  playVideoInHeader: (url: string) => void;
  clearActiveVideo: () => void;
}

// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = () => {};

export const HeaderVideoContext = React.createContext<HeaderVideoContextValue>({
  activeVideoUrl: null,
  playVideoInHeader: noop,
  clearActiveVideo: noop,
});

/** Access the header video context for lipsync playback control. */
export const useHeaderVideo = () => React.useContext(HeaderVideoContext);
